module.exports = __webpack_public_path__ + "img/article-blog.68798bcf.svg";